import ApisService from './index'
import { IProduct, IProductImport } from '../interfaces/productInterfaces'
import { handleError } from '../utils/commonUtils'
import * as queryString from 'query-string'
import { TypeId } from '../interfaces/commonInterfaces'

export function createProduct(data: IProduct) {
  let bodyData: any = { ...data }
  if (data.nhomCongBoSanPhamId != null && data.nhomCongBoSanPhamId != "" && data.ngayBatDauCongBo != null && data.ngayBatDauCongBo != "" && data.ngayKetThucCongBo != null && data.ngayKetThucCongBo != "") {
    bodyData = {
      ...data,
      ngayBatDauCongBo: Number(data.ngayBatDauCongBo),
      ngayKetThucCongBo: Number(data.ngayKetThucCongBo),
      nhomCongBoSanPhamId: Number(data.nhomCongBoSanPhamId),
    }
  } else {
    bodyData = {
      ...data,
      ngayBatDauCongBo: null,
      ngayKetThucCongBo: null,
      nhomCongBoSanPhamId: null,
    }
  }
  try {
    return ApisService.post('/sanpham/create-sanpham', bodyData)
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function updateProduct(data: IProduct) {
  let bodyData: any = { ...data }
  if (data.nhomCongBoSanPhamId != null && data.nhomCongBoSanPhamId != "" && data.ngayBatDauCongBo != null && data.ngayBatDauCongBo != "" && data.ngayKetThucCongBo != null && data.ngayKetThucCongBo != "") {
    bodyData = {
      ...data,
      ngayBatDauCongBo: Number(data.ngayBatDauCongBo),
      ngayKetThucCongBo: Number(data.ngayKetThucCongBo),
      nhomCongBoSanPhamId: Number(data.nhomCongBoSanPhamId),
    }
  } else {
    bodyData = {
      ...data,
      ngayBatDauCongBo: null,
      ngayKetThucCongBo: null,
      nhomCongBoSanPhamId: null,
    }
  }
  try {
    return ApisService.put('/sanpham/' + data.id + '/update-sanpham', bodyData)
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function getDetailProduct(id: TypeId) {
  try {
    return ApisService.get('/sanpham/' + id + '/get-chitiet-sanpham')
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function getListProduct(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisService.get('/sanpham/filter-sanpham', {
      params: query || {},
    })
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function deleteProduct(id: string) {
  try {
    return ApisService.delete('/sanpham/' + id + '/delete-sanpham')
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function deleteMultiProduct(idArr: Array<string>) {
  try {
    return ApisService.delete('/sanpham/bulk-delete-sanpham', { data: idArr })
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function importProduct(data: IProductImport) {
  try {
    return ApisService.post('/sanpham/import-sanpham', data, {
      timeout: 300000, // 5 phút (300000ms)
    })
  } catch (err) {
    handleError(err)
    throw err
  }
}